import { StandardEvents } from '@shopify/events';

/*
 * Stock Scarcity Badge (Trigger CRO #4)
 * Web component allineato al pattern del tema (vedi local-pickup.js):
 * ascolta StandardEvents.productSelect sulla sezione e legge resource.id
 * dal detail per determinare la variante corrente. L'inventario per variante
 * e' embeddato in un <script type="application/json"> perche' il detail
 * dell'evento non espone inventory_quantity.
 * Si nasconde se il tracking inventario e' off o la quantita' non e' sotto soglia.
 */
class ProductScarcityBadge extends HTMLElement {
  connectedCallback() {
    this.badge = this.querySelector('[data-scarcity-badge]');
    this.textEl = this.querySelector('[data-scarcity-text]');
    this.threshold = parseInt(this.dataset.threshold || '10', 10) || 10;
    this.template = this.dataset.template || 'Solo [X] rimasti — Molto richiesto';

    const invEl = this.querySelector('[data-scarcity-inventory]');
    try {
      this.inventory = invEl ? JSON.parse(invEl.textContent) : {};
    } catch (e) {
      this.inventory = {};
    }

    this.productId = this.dataset.productId;
    this.section = this.closest('.shopify-section');

    this.handleProductSelect = this.handleProductSelect.bind(this);
    this.section?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  handleProductSelect(event) {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail) return;
        const { resource, productId } = detail;
        if (productId && String(productId) !== String(this.productId)) return;
        this.update(resource ? resource.id : null);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[scarcity-badge] promise rejected:', error);
      });
  }

  update(variantId) {
    const data = variantId != null ? this.inventory[variantId] : null;

    if (!data || !data.m || data.q <= 0 || data.q > this.threshold) {
      this.hide();
      return;
    }
    this.show(data.q);
  }

  show(qty) {
    if (this.textEl) this.textEl.textContent = this.template.replace('[X]', qty);
    if (this.badge) this.badge.removeAttribute('hidden');
    this.classList.remove('da-scarcity--hidden');
  }

  hide() {
    if (this.badge) this.badge.setAttribute('hidden', '');
    this.classList.add('da-scarcity--hidden');
  }
}

if (!customElements.get('product-scarcity-badge')) {
  customElements.define('product-scarcity-badge', ProductScarcityBadge);
}
